export default {
	comments: {
		confirm_delete_comment: 'Möchten Sie den Kommentar wirklich löschen?',
	},
}
